module.exports = __webpack_public_path__ + "img/BF.8dfdfb26.png";